import { lazy } from "react";
import IRoute from "./IRoute";

// All four auth pages share form primitives + auth services. Vite's
// default chunk splitter co-locates them into a single auth chunk when
// the dynamic imports are sibling — exactly what we want here.
const LoginPage = lazy(() => import("../pages/Auth/LoginPage"));
const RegisterPage = lazy(() => import("../pages/Auth/RegisterPage"));
const ForgotPasswordPage = lazy(() => import("../pages/Auth/ForgotPasswordPage"));
const ResetPasswordPage = lazy(() => import("../pages/Auth/ResetPasswordPage"));

const authRoutes: IRoute = {
  path: "/auth",
  redirect: "/auth/login",
  children: [
    {
      path: "/login",
      component: LoginPage,
      needAuth: false,
    },
    {
      path: "/register",
      component: RegisterPage,
      needAuth: false,
    },
    {
      path: "/forgot-password",
      component: ForgotPasswordPage,
      needAuth: false,
    },
    {
      path: "/reset-password",
      component: ResetPasswordPage,
      needAuth: false,
    },
  ],
};

export default authRoutes;
